import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';

import {
	FormGroup,
	Label,
	Input,
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {   
    allStudents,
    allPSshots,
    select_PSshottype,
    select_PSshotdrill,
    addPracticeSchedule,
    addPracticeHeading,
    getPracticeHeading
 } from 'Actions';


 function TabContainer({ children }) {
    return (
       <Typography component="div" style={{ padding: 8 * 3 }}>
          {children}
       </Typography>
    );
 }

class EditPSElements2 extends React.Component {
   
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    static num1 = 0;

    constructor(props) {
      
      super(props);
        this.state = {
            student: this.props.data.student,            
            practshot_2_1_1:this.props.data.practshot_2_1_1,
            practtype_2_1_1:this.props.data.practtype_2_1_1,
            practdrill_2_1_1:this.props.data.practdrill_2_1_1,
            typeopt_2_1_1:this.props.data.typeopt_2_1_1,
            drillopt_2_1_1:this.props.data.drillopt_2_1_1,
            edpractdrill_2_1_1:this.props.data.edpractdrill_2_1_1,

            practshot_2_1_2:this.props.data.practshot_2_1_2,
            practtype_2_1_2:this.props.data.practtype_2_1_2,
            practdrill_2_1_2:this.props.data.practdrill_2_1_2,
            typeopt_2_1_2:this.props.data.typeopt_2_1_2,
            drillopt_2_1_2:this.props.data.drillopt_2_1_2,
            edpractdrill_2_1_2:this.props.data.edpractdrill_2_1_2,

            practshot_2_1_3:this.props.data.practshot_2_1_3,
            practtype_2_1_3:this.props.data.practtype_2_1_3,
            practdrill_2_1_3:this.props.data.practdrill_2_1_3,
            typeopt_2_1_3:this.props.data.typeopt_2_1_3,
            drillopt_2_1_3:this.props.data.drillopt_2_1_3,
            edpractdrill_2_1_3:this.props.data.edpractdrill_2_1_3,

            practshot_2_1_4:this.props.data.practshot_2_1_4,
            practtype_2_1_4:this.props.data.practtype_2_1_4,
            practdrill_2_1_4:this.props.data.practdrill_2_1_4,
            typeopt_2_1_4:this.props.data.typeopt_2_1_4,
            drillopt_2_1_4:this.props.data.drillopt_2_1_4,
            edpractdrill_2_1_4:this.props.data.edpractdrill_2_1_4,

            practshot_2_1_5:this.props.data.practshot_2_1_5,
            practtype_2_1_5:this.props.data.practtype_2_1_5,
            practdrill_2_1_5:this.props.data.practdrill_2_1_5,
            typeopt_2_1_5:this.props.data.typeopt_2_1_5,
            drillopt_2_1_5:this.props.data.drillopt_2_1_5,
            edpractdrill_2_1_5:this.props.data.edpractdrill_2_1_5,

            //tuesday           
            practshot_2_2_1:this.props.data.practshot_2_2_1,
            practtype_2_2_1:this.props.data.practtype_2_2_1,
            practdrill_2_2_1:this.props.data.practdrill_2_2_1,
            typeopt_2_2_1:this.props.data.typeopt_2_2_1,
            drillopt_2_2_1:this.props.data.drillopt_2_2_1,
            edpractdrill_2_2_1:this.props.data.edpractdrill_2_2_1,

            practshot_2_2_2:this.props.data.practshot_2_2_2,
            practtype_2_2_2:this.props.data.practtype_2_2_2,
            practdrill_2_2_2:this.props.data.practdrill_2_2_2,
            typeopt_2_2_2:this.props.data.typeopt_2_2_2,
            drillopt_2_2_2:this.props.data.drillopt_2_2_2,
            edpractdrill_2_2_2:this.props.data.edpractdrill_2_2_2,

            practshot_2_2_3:this.props.data.practshot_2_2_3,
            practtype_2_2_3:this.props.data.practtype_2_2_3,
            practdrill_2_2_3:this.props.data.practdrill_2_2_3,
            typeopt_2_2_3:this.props.data.typeopt_2_2_3,
            drillopt_2_2_3:this.props.data.drillopt_2_2_3,
            edpractdrill_2_2_3:this.props.data.edpractdrill_2_2_3,

            practshot_2_2_4:this.props.data.practshot_2_2_4,
            practtype_2_2_4:this.props.data.practtype_2_2_4,
            practdrill_2_2_4:this.props.data.practdrill_2_2_4,
            typeopt_2_2_4:this.props.data.typeopt_2_2_4,
            drillopt_2_2_4:this.props.data.drillopt_2_2_4,
            edpractdrill_2_2_4:this.props.data.edpractdrill_2_2_4,

            practshot_2_2_5:this.props.data.practshot_2_2_5,
            practtype_2_2_5:this.props.data.practtype_2_2_5,
            practdrill_2_2_5:this.props.data.practdrill_2_2_5,
            typeopt_2_2_5:this.props.data.typeopt_2_2_5,
            drillopt_2_2_5:this.props.data.drillopt_2_2_5,
            edpractdrill_2_2_5:this.props.data.edpractdrill_2_2_5,
            //Wednesday           
            practshot_2_3_1:this.props.data.practshot_2_3_1,
            practtype_2_3_1:this.props.data.practtype_2_3_1,
            practdrill_2_3_1:this.props.data.practdrill_2_3_1,
            typeopt_2_3_1:this.props.data.typeopt_2_3_1,
            drillopt_2_3_1:this.props.data.drillopt_2_3_1,
            edpractdrill_2_3_1:this.props.data.edpractdrill_2_3_1,

            practshot_2_3_2:this.props.data.practshot_2_3_2,
            practtype_2_3_2:this.props.data.practtype_2_3_2,
            practdrill_2_3_2:this.props.data.practdrill_2_3_2,
            typeopt_2_3_2:this.props.data.typeopt_2_3_2,
            drillopt_2_3_2:this.props.data.drillopt_2_3_2,
            edpractdrill_2_3_2:this.props.data.edpractdrill_2_3_2,

            practshot_2_3_3:this.props.data.practshot_2_3_3,
            practtype_2_3_3:this.props.data.practtype_2_3_3,
            practdrill_2_3_3:this.props.data.practdrill_2_3_3,
            typeopt_2_3_3:this.props.data.typeopt_2_3_3,
            drillopt_2_3_3:this.props.data.drillopt_2_3_3,
            edpractdrill_2_3_3:this.props.data.edpractdrill_2_3_3,

            practshot_2_3_4:this.props.data.practshot_2_3_4,
            practtype_2_3_4:this.props.data.practtype_2_3_4,
            practdrill_2_3_4:this.props.data.practdrill_2_3_4,
            typeopt_2_3_4:this.props.data.typeopt_2_3_4,
            drillopt_2_3_4:this.props.data.drillopt_2_3_4,
            edpractdrill_2_3_4:this.props.data.edpractdrill_2_3_4,

            practshot_2_3_5:this.props.data.practshot_2_3_5,
            practtype_2_3_5:this.props.data.practtype_2_3_5,
            practdrill_2_3_5:this.props.data.practdrill_2_3_5,
            typeopt_2_3_5:this.props.data.typeopt_2_3_5,
            drillopt_2_3_5:this.props.data.drillopt_2_3_5,
            edpractdrill_2_3_5:this.props.data.edpractdrill_2_3_5,
            // Thursday
            practshot_2_4_1:this.props.data.practshot_2_4_1,
            practtype_2_4_1:this.props.data.practtype_2_4_1,
            practdrill_2_4_1:this.props.data.practdrill_2_4_1,
            typeopt_2_4_1:this.props.data.typeopt_2_4_1,
            drillopt_2_4_1:this.props.data.drillopt_2_4_1,
            edpractdrill_2_4_1:this.props.data.edpractdrill_2_4_1,

            practshot_2_4_2:this.props.data.practshot_2_4_2,
            practtype_2_4_2:this.props.data.practtype_2_4_2,
            practdrill_2_4_2:this.props.data.practdrill_2_4_2,
            typeopt_2_4_2:this.props.data.typeopt_2_4_2,
            drillopt_2_4_2:this.props.data.drillopt_2_4_2,
            edpractdrill_2_4_2:this.props.data.edpractdrill_2_4_2,

            practshot_2_4_3:this.props.data.practshot_2_4_3,
            practtype_2_4_3:this.props.data.practtype_2_4_3,
            practdrill_2_4_3:this.props.data.practdrill_2_4_3,
            typeopt_2_4_3:this.props.data.typeopt_2_4_3,
            drillopt_2_4_3:this.props.data.drillopt_2_4_3,
            edpractdrill_2_4_3:this.props.data.edpractdrill_2_4_3,

            practshot_2_4_4:this.props.data.practshot_2_4_4,
            practtype_2_4_4:this.props.data.practtype_2_4_4,
            practdrill_2_4_4:this.props.data.practdrill_2_4_4,
            typeopt_2_4_4:this.props.data.typeopt_2_4_4,
            drillopt_2_4_4:this.props.data.drillopt_2_4_4,
            edpractdrill_2_4_4:this.props.data.edpractdrill_2_4_4,

            practshot_2_4_5:this.props.data.practshot_2_4_5,
            practtype_2_4_5:this.props.data.practtype_2_4_5,
            practdrill_2_4_5:this.props.data.practdrill_2_4_5,
            typeopt_2_4_5:this.props.data.typeopt_2_4_5,
            drillopt_2_4_5:this.props.data.drillopt_2_4_5,
            edpractdrill_2_4_5:this.props.data.edpractdrill_2_4_5,
            //Friday
            practshot_2_5_1:this.props.data.practshot_2_5_1,
            practtype_2_5_1:this.props.data.practtype_2_5_1,
            practdrill_2_5_1:this.props.data.practdrill_2_5_1,
            typeopt_2_5_1:this.props.data.typeopt_2_5_1,
            drillopt_2_5_1:this.props.data.drillopt_2_5_1,
            edpractdrill_2_5_1:this.props.data.edpractdrill_2_5_1,

            practshot_2_5_2:this.props.data.practshot_2_5_2,
            practtype_2_5_2:this.props.data.practtype_2_5_2,
            practdrill_2_5_2:this.props.data.practdrill_2_5_2,
            typeopt_2_5_2:this.props.data.typeopt_2_5_2,
            drillopt_2_5_2:this.props.data.drillopt_2_5_2,
            edpractdrill_2_5_2:this.props.data.edpractdrill_2_5_2,

            practshot_2_5_3:this.props.data.practshot_2_5_3,
            practtype_2_5_3:this.props.data.practtype_2_5_3,
            practdrill_2_5_3:this.props.data.practdrill_2_5_3,
            typeopt_2_5_3:this.props.data.typeopt_2_5_3,
            drillopt_2_5_3:this.props.data.drillopt_2_5_3,
            edpractdrill_2_5_3:this.props.data.edpractdrill_2_5_3,

            practshot_2_5_4:this.props.data.practshot_2_5_4,
            practtype_2_5_4:this.props.data.practtype_2_5_4,
            practdrill_2_5_4:this.props.data.practdrill_2_5_4,
            typeopt_2_5_4:this.props.data.typeopt_2_5_4,
            drillopt_2_5_4:this.props.data.drillopt_2_5_4,
            edpractdrill_2_5_4:this.props.data.edpractdrill_2_5_4,

            practshot_2_5_5:this.props.data.practshot_2_5_5,
            practtype_2_5_5:this.props.data.practtype_2_5_5,
            practdrill_2_5_5:this.props.data.practdrill_2_5_5,
            typeopt_2_5_5:this.props.data.typeopt_2_5_5,
            drillopt_2_5_5:this.props.data.drillopt_2_5_5,
            edpractdrill_2_5_5:this.props.data.edpractdrill_2_5_5,
            //Saturday
            practshot_2_6_1:this.props.data.practshot_2_6_1,
            practtype_2_6_1:this.props.data.practtype_2_6_1,
            practdrill_2_6_1:this.props.data.practdrill_2_6_1,
            typeopt_2_6_1:this.props.data.typeopt_2_6_1,
            drillopt_2_6_1:this.props.data.drillopt_2_6_1,
            edpractdrill_2_6_1:this.props.data.edpractdrill_2_6_1,

            practshot_2_6_2:this.props.data.practshot_2_6_2,
            practtype_2_6_2:this.props.data.practtype_2_6_2,
            practdrill_2_6_2:this.props.data.practdrill_2_6_2,
            typeopt_2_6_2:this.props.data.typeopt_2_6_2,
            drillopt_2_6_2:this.props.data.drillopt_2_6_2,
            edpractdrill_2_6_2:this.props.data.edpractdrill_2_6_2,

            practshot_2_6_3:this.props.data.practshot_2_6_3,
            practtype_2_6_3:this.props.data.practtype_2_6_3,
            practdrill_2_6_3:this.props.data.practdrill_2_6_3,
            typeopt_2_6_3:this.props.data.typeopt_2_6_3,
            drillopt_2_6_3:this.props.data.drillopt_2_6_3,
            edpractdrill_2_6_3:this.props.data.edpractdrill_2_6_3,

            practshot_2_6_4:this.props.data.practshot_2_6_4,
            practtype_2_6_4:this.props.data.practtype_2_6_4,
            practdrill_2_6_4:this.props.data.practdrill_2_6_4,
            typeopt_2_6_4:this.props.data.typeopt_2_6_4,
            drillopt_2_6_4:this.props.data.drillopt_2_6_4,
            edpractdrill_2_6_4:this.props.data.edpractdrill_2_6_4,

            practshot_2_6_5:this.props.data.practshot_2_6_5,
            practtype_2_6_5:this.props.data.practtype_2_6_5,
            practdrill_2_6_5:this.props.data.practdrill_2_6_5,
            typeopt_2_6_5:this.props.data.typeopt_2_6_5,
            drillopt_2_6_5:this.props.data.drillopt_2_6_5,
            edpractdrill_2_6_5:this.props.data.edpractdrill_2_6_5,
            //Sunday
            practshot_2_7_1:this.props.data.practshot_2_7_1,
            practtype_2_7_1:this.props.data.practtype_2_7_1,
            practdrill_2_7_1:this.props.data.practdrill_2_7_1,
            typeopt_2_7_1:this.props.data.typeopt_2_7_1,
            drillopt_2_7_1:this.props.data.drillopt_2_7_1,
            edpractdrill_2_7_1:this.props.data.edpractdrill_2_7_1,

            practshot_2_7_2:this.props.data.practshot_2_7_2,
            practtype_2_7_2:this.props.data.practtype_2_7_2,
            practdrill_2_7_2:this.props.data.practdrill_2_7_2,
            typeopt_2_7_2:this.props.data.typeopt_2_7_2,
            drillopt_2_7_2:this.props.data.drillopt_2_7_2,
            edpractdrill_2_7_2:this.props.data.edpractdrill_2_7_2,

            practshot_2_7_3:this.props.data.practshot_2_7_3,
            practtype_2_7_3:this.props.data.practtype_2_7_3,
            practdrill_2_7_3:this.props.data.practdrill_2_7_3,
            typeopt_2_7_3:this.props.data.typeopt_2_7_3,
            drillopt_2_7_3:this.props.data.drillopt_2_7_3,
            edpractdrill_2_7_3:this.props.data.edpractdrill_2_7_3,

            practshot_2_7_4:this.props.data.practshot_2_7_4,
            practtype_2_7_4:this.props.data.practtype_2_7_4,
            practdrill_2_7_4:this.props.data.practdrill_2_7_4,
            typeopt_2_7_4:this.props.data.typeopt_2_7_4,
            drillopt_2_7_4:this.props.data.drillopt_2_7_4,
            edpractdrill_2_7_4:this.props.data.edpractdrill_2_7_4,

            practshot_2_7_5:this.props.data.practshot_2_7_5,
            practtype_2_7_5:this.props.data.practtype_2_7_5,
            practdrill_2_7_5:this.props.data.practdrill_2_7_5,
            typeopt_2_7_5:this.props.data.typeopt_2_7_5,
            drillopt_2_7_5:this.props.data.drillopt_2_7_5,
            edpractdrill_2_7_5:this.props.data.edpractdrill_2_7_5,
            
            activeIndex:0,

            shwdrill_1_1:false,
            shwdrill_1_2:false,
            shwdrill_1_3:false,
            shwdrill_1_4:false,
            shwdrill_1_5:false,

            shwdrill_2_1:false,
            shwdrill_2_2:false,
            shwdrill_2_3:false,
            shwdrill_2_4:false,
            shwdrill_2_5:false,

            shwdrill_3_1:false,
            shwdrill_3_2:false,
            shwdrill_3_3:false,
            shwdrill_3_4:false,
            shwdrill_3_5:false,

            shwdrill_4_1:false,
            shwdrill_4_2:false,
            shwdrill_4_3:false,
            shwdrill_4_4:false,
            shwdrill_4_5:false,

            shwdrill_5_1:false,
            shwdrill_5_2:false,
            shwdrill_5_3:false,
            shwdrill_5_4:false,
            shwdrill_5_5:false,

            shwdrill_6_1:false,
            shwdrill_6_2:false,
            shwdrill_6_3:false,
            shwdrill_6_4:false,
            shwdrill_6_5:false,

            shwdrill_7_1:false,
            shwdrill_7_2:false,
            shwdrill_7_3:false,
            shwdrill_7_4:false,
            shwdrill_7_5:false,
            weekheading:'',
        };
        
    } 
    
    UNSAFE_componentWillMount() {
		this.props.allStudents();   
        this.props.allPSshots();
        var student=this.state.student;
        // this.props.getPracticeHeading(student, 2).then((data) => {  

        //     if(data.status==1){
        //         var resdata=data.data;
        //         this.setState({ 
        //             weekheading:resdata[0].gph_heading 
        //         });
        //     }
        // });
        this.props.getPracticeHeading(student, 2).then((data) => {  
    if (data.status === 1 && Array.isArray(data.data) && data.data.length > 0) {
        const resdata = data.data;
        this.setState({ 
            weekheading: resdata[0].gph_heading 
        });
    } else {
        this.setState({
            weekheading: "No heading available"
        });
    }
});

	}

    addHandleSubmit(event){
        event.preventDefault();        
        var studentid=this.state.student;
        var headingval=this.state.weekheading;
        this.props.addPracticeSchedule(event,studentid);
        this.props.addPracticeHeading(studentid, 2, headingval);
    }

    handleChange(value) {
        this.setState({ activeIndex: value });
    }

    selshot(event){

        var shotid=event.target.value;
        var labelname=event.target.name;
        var spltval=labelname.split('_');        
        var shotype="typeopt_"+spltval[1]+"_"+spltval[2]+"_"+spltval[3];
        var shotdrill="drillopt_"+spltval[1]+"_"+spltval[2]+"_"+spltval[3];
        var eddrill="edpractdrill_"+spltval[1]+"_"+spltval[2]+"_"+spltval[3];
        var reshot="practshot_"+spltval[1]+"_"+spltval[2]+"_"+spltval[3];
        this.setState({ 
            [reshot]:shotid,
            [shotype]:[],
            [shotdrill]:[],
            [eddrill]:'',
        });

        this.props.select_PSshottype(shotid).then((data) => {   

            if(data.status==1){
                var resdata=data.data;
                this.setState({ 
                    [labelname]:shotid,
                    [shotype]:resdata
                });
                
            }
        });

    }

    seltype(event){

        var typeid=event.target.value;
        var labelname=event.target.name;        
        var spltval=labelname.split('_');       
        var shotdrill="drillopt_"+spltval[1]+"_"+spltval[2]+"_"+spltval[3];
        var shotval="practshot_"+spltval[1]+"_"+spltval[2]+"_"+spltval[3];
        var shotid=this.state[shotval];
        var eddrill="edpractdrill_"+spltval[1]+"_"+spltval[2]+"_"+spltval[3];
        var restype="practtype_"+spltval[1]+"_"+spltval[2]+"_"+spltval[3];
        this.setState({ 
            [restype]:typeid,
            [shotdrill]:[],
            [eddrill]:'',
        });
        
        this.props.select_PSshotdrill(shotid, typeid).then((data) => {   

            if(data.status==1){
                var resdata=data.data;
                this.setState({ 
                    [shotdrill]:resdata
                });
                
            }
        });

    }

    seldrill(event){
        const { label, value } = event.target.selectedOptions[0];       
        var labelname=event.target.name;
        var spltval=labelname.split('_');       
        var shotdrill="edpractdrill_"+spltval[1]+"_"+spltval[2]+"_"+spltval[3];
        var resdril="practdrill_"+spltval[1]+"_"+spltval[2]+"_"+spltval[3];
        var shwlble="shwdrill_"+spltval[2]+"_"+spltval[3];

        this.setState({ 
            [resdril]:value,
            [shotdrill]:label,
            [shwlble]:!this.state[shwlble]
        });

    } 
    
    seleddrill(event){
        var edval = event.target.value;       
        var labelname=event.target.name;
        var spltval=labelname.split('_');       
        var shotdrill="edpractdrill_"+spltval[1]+"_"+spltval[2]+"_"+spltval[3];
        this.setState({ 
            [shotdrill]:edval
        });

    } 

    drillshow(evt,val1, val2){

        evt.preventDefault();     
        
        var shwlble="shwdrill_"+val1+"_"+val2;
        this.setState({ 
            [shwlble]:!this.state[shwlble]
        });
       

    }

    handleheadChange(e){
        var inputval=e.target.value;
        this.setState({ 
            weekheading:inputval
        });
    }

  

   render() {
      
      const { studentlists, studentpracticelist, allshotlist, loading} = this.props;

      const allstudent=studentlists.map((stdval) => {  
            return {
               label: stdval.student,  
               value: stdval.uudID
            }
      });
      return (
           <div>
               <div className="col-md-12">
                    
                        <div className="row">
                            <div className="col-sm-12 col-md-10" style={{margin:"0 auto"}}>
                                <div><div className="col-sm-12 col-lg-6" style={{margin:"0 auto"}}> <input type="text" name="weekheading" id="weekheading" className="form-control form-control-alternative" value={this.state.weekheading} placeholder="Week 2 Heading" onChange={e => this.handleheadChange(e)}/></div></div>
                                <div className="eachweek">
                                        <Tabs
                                            value={this.state.activeIndex}
                                            onChange={(e, value) => this.handleChange(value)}                                                                                        
                                            variant="scrollable"
                                            scrollButtons="on">
                                            <Tab label="Day 1" style={{fontWeight:"bold"}}/>
                                            <Tab label="Day 2" style={{fontWeight:"bold"}}/>
                                            <Tab label="Day 3" style={{fontWeight:"bold"}}/>
                                            <Tab label="Day 4" style={{fontWeight:"bold"}}/>
                                            <Tab label="Day 5" style={{fontWeight:"bold"}}/>
                                            <Tab label="Day 6" style={{fontWeight:"bold"}}/>
                                            <Tab label="Day 7" style={{fontWeight:"bold"}}/>
                                        </Tabs>
                                    
                                    {(() => {
                                        let Fragment = [];
                                        
                                        for (let j = 1; j <=7; j++) {
                                            var tablename="Day "+j;
                                            var tabval=j-1;
                                            {this.state.activeIndex === tabval && 
                                                
                                                Fragment.push(<TabContainer>
                                                    <form autoComplete="off" id="addassessmentform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                                                    <RctCollapsibleCard heading={tablename} fullBlock>
                                            <div className="table-responsive">
                                                <Table>
                                                    <TableHead>
                                                        <TableRow hover>
                                                            <TableCell >Session</TableCell>
                                                            <TableCell align="center" style={{width:"20%"}}>Shot</TableCell>
                                                            <TableCell align="center" style={{width:"20%"}}>Type</TableCell>
                                                            <TableCell align="center" style={{width:"50%"}}>Practice Drill</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                            {(() => {
                                                                let td = [];
                                                                
                                                                for (let i = 1; i <=5; i++) {
                                                                    var nametype="typeopt_2_"+j+"_"+i;
                                                                    var lsttype=this.state[nametype];
                                                                    var namedrill="drillopt_2_"+j+"_"+i;
                                                                    var lstdrill=this.state[namedrill];
                                                                    
                                                                    var shotlabel="practshot_2_"+j+"_"+i;
                                                                    var resshot=this.state[shotlabel];
                                                                    var typelabel="practtype_2_"+j+"_"+i;
                                                                    var restype=this.state[typelabel];
                                                                    var drilllabel="practdrill_2_"+j+"_"+i;
                                                                    var resdrill=this.state[drilllabel];
                                                                    var eddrllabel="edpractdrill_2_"+j+"_"+i;
                                                                    var reseddrl=this.state[eddrllabel];

                                                                    var shwlble="shwdrill_"+j+"_"+i;
                                                                    var shwedrl=this.state[shwlble];

                                                                    td.push(
                                                                        <TableRow key={i}>
                                                                            <TableCell>{i}</TableCell>
                                                                            <TableCell>
                                                                                <select name={'practshot_2_'+j+'_'+i} id={'practshot_2_'+j+'_'+i} value={resshot} className="form-control form-control-alternative" onChange={evt => this.selshot(evt)} style={{ appearance: 'none'}}>
                                                                                    <option value=""></option>
                                                                                    {allshotlist.map((shotval) => ( 
                                                                                    <option value={shotval.gpsID}>{shotval.gps_shot}</option>                                                    
                                                                                    ))}
                                                                                </select>    
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <select name={'practtype_2_'+j+'_'+i} id={'practtype_2_'+j+'_'+i} value={restype} className="form-control form-control-alternative" onChange={evt => this.seltype(evt)} style={{ appearance: 'none'}}>
                                                                                    <option value=""></option>
                                                                                    {lsttype.map((optval) => ( 
                                                                                        <option value={optval.gpd_sheadID}>{optval.gpsh_name}</option>                                                           
                                                                                    ))}
                                                                                </select>    
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                    <span style={{color:"blue", cursor:"pointer", float:"right"}} onClick={evt => this.drillshow(evt, j,i)}>change drill</span>
                                                                                    {shwedrl &&
                                                                                    <select name={'selpractdril_2_'+j+'_'+i} id={'selpractdril_2_'+j+'_'+i} value={resdrill} className="form-control form-control-alternative" onChange={evt => this.seldrill(evt)} style={{ appearance: 'none'}}>
                                                                                        <option value=""></option>
                                                                                        {lstdrill.map((optval) => ( 
                                                                                            <option value={optval.gpdID}>{optval.gpd_desc}</option>                                                           
                                                                                        ))}
                                                                                    </select> 
                                                                                    }  
                                                                                    <input type="hidden" name={'practdril_2_'+j+'_'+i} id={'practdril_2_'+j+'_'+i} value={resdrill}/>
                                                                                    <textarea rows="2" type="text" name={'edpractdrill_2_'+j+'_'+i}  id={'edpractdrill_2_'+j+'_'+i} className="form-control form-control-alternative" value={reseddrl} onChange={evt => this.seleddrill(evt)}></textarea> 
                                                                            </TableCell>                                                       
                                                                        </TableRow>
                                                                    );

                                                                }
                                                                return td;
                                                            })()} 
                                                    </TableBody>
                                                </Table>
                                            </div>
                                            </RctCollapsibleCard>
                                                <div className="row">
                                                    <div className="form-group">
                                                        <input type="hidden" name="weekval" id="weekval" value="2"></input>
                                                        <input type="hidden" name="dayval" id="dayval" value={j}></input>
                                                        <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />
                                                    </div>
                                                </div>
                                            </form>
                                            </TabContainer>);
                                            }
                                            }
                                            return Fragment;
                                            })()}  

                                    
                                </div>
                                
                            </div>
                        </div>
                        
                     
                </div>
         </div>
      );
   }
}


const mapStateToProps = ({ mostlyused, practiceschedule }) => {
    const { studentlists, loading } = mostlyused;
	const { studentpracticelist, allshotlist } = practiceschedule;
    return { studentlists, studentpracticelist, allshotlist, loading };
}

export default connect(mapStateToProps, {
    allStudents,
    allPSshots,
    select_PSshottype,
    select_PSshotdrill,
    addPracticeSchedule,
    addPracticeHeading,
    getPracticeHeading
})(EditPSElements2); 